import createDebugger from 'debug'

export default createDebugger('niederstätter')
